import anime from 'animejs';
import scrollService from '../core/ScrollService.js';

const initSearchbar = () => {
    const openButton = document.querySelector('#nav-megamenu .navbar .navSearch.button')
        || document.querySelector('#nav-megamenu .navSearch.button')
        || document.querySelector('#nav-megamenu .navSearch');
    const shadow = document.querySelector('.searchBar_shadow')
        || document.querySelector('.searchBar__shadow');
    const searchBar = document.querySelector('.searchBar')
    const toAnime = document.querySelectorAll('.suggestions .anime')
    const handleOpenSearch = () => {
        if (searchBar) searchBar.classList.toggle('open')
        if (openButton) openButton.classList.toggle('open')
        if (toAnime.length > 0) {
            anime({
                targets: toAnime,
                opacity: [0, 1],
                translateX: [-10, 0],
                easing: 'easeOutExpo',
                duration: 1000,
                delay: anime.stagger(200)
            })
        }

        if (openButton?.classList.contains('open')) {
            scrollService.stop();
            let activeMenuItem = document.querySelector('.mainNav a.current');
            if (activeMenuItem) {
                activeMenuItem.classList.remove('current');
                activeMenuItem.setAttribute('aria-expanded', 'false');
            }
             
            let megaMenu = document.querySelector('.nav-megamenu');
            if (megaMenu) {
                megaMenu.classList.remove('nav-megamenu--mobile-open');
                megaMenu.classList.remove('nav-megamenu--mobile-submenu');
            }
            
            // Desktop
            let megaMenuItem = document.querySelector('.nav-megamenu__megamenu.is-visible');
            let megaMenuBackdrop = document.querySelector('.nav-megamenu__backdrop');

            if (megaMenuItem) {
                megaMenuItem.classList.remove('is-visible');
                megaMenuItem.setAttribute('aria-hidden', 'true');
                megaMenuItem.setAttribute('hidden', '');
                
                megaMenuBackdrop.classList.remove('is-visible');
            }

            // Mobile
            let mobileMenu = document.querySelector('.nav-megamenu__mobile');
            if (mobileMenu) {
                mobileMenu.classList.remove('nav-megamenu__mobile--open');
                mobileMenu.setAttribute('aria-hidden', 'true');
                mobileMenu.setAttribute('hidden', '');
                document.querySelector('.navbar_mobileToggle').classList.remove('opened');
                document.querySelector('.navbar_mobileToggle').setAttribute('aria-expanded', 'false');
            }
        } else {
            scrollService.start();
        }
    }
    if (openButton) {
        openButton.addEventListener('click', handleOpenSearch)
    }
    if (shadow) {
        shadow.addEventListener('click', handleOpenSearch)
    }
}

export { initSearchbar };
